import { createContext, useState, useEffect, useContext } from "react";

const DialogFormContext = createContext();

const useDialogForm = () => useContext(DialogFormContext);

// this is a context that will be used to pass a function to children to submit the form
const DialogFormProvider = ({ children, forceClose = () => {}, forceOpen = false }) => {

    const [open, setOpen] = useState(false);
  
    const handleClickOpen = (e) => {
      if (e) e.stopPropagation(); // HOPE NO REPERCUSSIONS
      setOpen(true);
    };

    console.log(open, "open");
  
    const handleClose = (e) => {
      if (e) e.stopPropagation(); // HOPE NO REPERCUSSIONS
      forceClose();
      setOpen(false);
    };
  
    useEffect(() => {
      setOpen(forceOpen);
    }, [forceOpen]);


  const dialogProps = {
   open,
   setOpen,
   handleClickOpen,
   handleClose
  }

  return (
    <DialogFormContext.Provider value={dialogProps}>
      {children}
    </DialogFormContext.Provider>
  );
}

export { DialogFormProvider, useDialogForm, DialogFormContext };